export const generateSubmitPayload = (deceasedDetails, submitterDetails, deceasedDetailsEnabled) => {
  const {
    dfName,
    dmName,
    dlName,
    dSuffix,
    dAddress,
    dDOB,
    dSSN,
    dAccountNum,
    dDeathCert,
    dDOD
  } = deceasedDetails;

  const {
    pfName,
    pmName,
    plName,
    pSuffix,
    pPhoneNum,
    pEmail,
    pAddress,
    pRelationToDeceased,
    pExecutor
  } = submitterDetails;

  const {
    enableAddress,
    enableDOB,
    enableSSN,
    enableAccountNum,
    enableDeathCert
  } = deceasedDetailsEnabled;
  return {
    deathCert: enableDeathCert ? dDeathCert : null,
    decedent: {
      firstName: dfName,
      middleName: dmName,
      lastName: dlName,
      suffixName: dSuffix,
      maskedSSN: enableSSN ? dSSN : null,
      accountNumber: enableAccountNum ? dAccountNum : null,
      dateOfBirth: enableDOB ? dDOB : null,
      dateOfDeath: dDOD,
      address: enableAddress
        ? {
          '@Type': 'Address',
          street1: dAddress.dAddressOne,
          street2: dAddress.dAddressTwo,
          city: dAddress.dAddressCity,
          stateProvince: dAddress.dAddressState,
          postalCode: dAddress.dAddressZip,
          country: dAddress.dAddressMilitary ? 'Military' : 'US'
        }
        : null
    },
    submitter: {
      firstName: pfName,
      middleName: pmName,
      lastName: plName,
      suffixName: pSuffix,
      phone: pPhoneNum.substring(1),
      email: pEmail,
      address: {
        '@Type': 'Address',
        street1: pAddress.pAddressOne,
        street2: pAddress.pAddressTwo,
        city: pAddress.pAddressCity,
        stateProvince: pAddress.pAddressState,
        postalCode: pAddress.pAddressZip,
        country: pAddress.pAddressMilitary ? 'Military' : 'US',
      },
      relationship: getRelationshipEnum(pRelationToDeceased),
      deathCertificateIncluded: enableDeathCert && dDeathCert ? true : false,
      executor: getExecutorEnum(pExecutor)
    }
  };
};

export const generateBEPPayload = details => {
  return {
    emailAddress: details.pEmail,
    firstName: details.pfName,
    lastName: details.plName
  };
};

const getExecutorEnum = executor => {
  if(executor === 'Yes') {
    return {
      enumerationID: 1,
      enumerationName: 'Yes'
    }
  } else if(executor === 'No') {
    return {
      enumerationID: 2,
      enumerationName: 'No'
    }
  } else if(executor === 'I don\'t know') {
    return {
      enumerationID: 3,
      enumerationName: 'I Don\'t Know'
    }
  }
};

const getRelationshipEnum = relationship => {
  if(relationship === 'Spouse') {
    return {
      enumerationID: 1,
      enumerationName: 'Spouse'
    }
  } else if(relationship === 'Child') {
    return {
      enumerationID: 2,
      enumerationName: 'Child'
    }
  } else if(relationship === 'Parent') {
    return {
      enumerationID: 3,
      enumerationName: 'Parent'
    }
  } else if(relationship === 'Sibling') {
    return {
      enumerationID: 4,
      enumerationName: 'Sibling'
    }
  } else if(relationship === 'Financial/Legal Advisor') {
    return {
      enumerationID: 5,
      enumerationName: 'Financial/Legal Advisor'
    }
  } else if(relationship === 'Other') {
    return {
      enumerationID: 6,
      enumerationName: 'Other'
    }
  }
};